__turbopack_context__.v({
  "aside": "StickyFooter-module__jtW4eG__aside",
  "info": "StickyFooter-module__jtW4eG__info",
  "priceButton": "StickyFooter-module__jtW4eG__priceButton",
  "priceSuffix": "StickyFooter-module__jtW4eG__priceSuffix",
  "priceValue": "StickyFooter-module__jtW4eG__priceValue",
  "summary": "StickyFooter-module__jtW4eG__summary",
});
